import React, { useCallback, useMemo } from 'react';
import { Box, Heading, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { ButtonGrid, ButtonGridItem } from '../../../../components/ButtonGrid';
import s from './DomainMain.scss';
import { DomainInput } from '../../components/DomainInput';
import { useDomainLogic } from '../../hooks/useDomainLogic';
import { useDomainData } from '../../context/domainAtoms';
import { useBiLogger } from '../../../../hooks/useBiLogger/useBiLogger';
import { BI_CONSTANTS } from '../../../../hooks/useBiLogger/biConstants';

export function DomainMain() {
  const { t } = useTranslation();
  const { suggestions } = useDomainData();
  const { search, selectedSuggestion } = useDomainLogic();
  const biLogger = useBiLogger();

  const onItemSelect = useCallback(
    (value: string) => {
      biLogger.actionClicked({
        action: BI_CONSTANTS.ACTION.DOMAIN_PAGE_SUGGESTION_SELECT,
        button_name: BI_CONSTANTS.BUTTON_NAME.SELECT,
        value,
      });
      selectedSuggestion.onSelect(value);
    },
    [biLogger, selectedSuggestion],
  );

  const items = useMemo(() => {
    return suggestions.map<ButtonGridItem>((domain) => ({
      onClick: () => onItemSelect(domain),
      value: domain,
      label: domain,
      key: domain,
    }));
  }, [suggestions, onItemSelect]);

  return (
    <Box direction="vertical" height="100%" width="100%" gap={4}>
      <Box direction="vertical" gap={1}>
        <Heading className={s.textTitle} size="medium">
          {t('DOMAIN_PAGE_TITLE')}
        </Heading>

        <Text className={s.textSubtitle}>{t('DOMAIN_PAGE_SUBTITLE')}</Text>
      </Box>

      <DomainInput value={search.value} onChange={search.onChange} />

      {items.length ? (
        <Box direction="vertical" gap={2}>
          <Box align="space-between" verticalAlign="middle">
            <Text weight="bold">{t('DOMAIN_PAGE_MORE_AVAILABLE_DOMAINS')}</Text>
          </Box>

          <ButtonGrid items={items} selectedValue={selectedSuggestion.value} />
        </Box>
      ) : null}
    </Box>
  );
}
